<template>
    <div>
    <v-card raised class="mb-4">
    <v-layout row wrap>
    <v-flex xs12 md6 :style="fieldColor()">
        <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
        <v-flex d-flex xs8 style="padding-right: 6px">{{batchRegistration.AgreementNo}} - {{batchRegistration.AgreementName}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
        <v-flex d-flex xs8 style="padding-right: 6px">{{batchRegistration.CustomerNo}} - {{batchRegistration.CustomerName}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
        <v-flex d-flex xs8 style="padding-right: 6px">{{batchRegistration.PlantNo}} - {{batchRegistration.PlantName}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Carrier')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Carrier")}}:</v-flex>
        <v-flex d-flex xs8 style="padding-right: 6px">{{batchRegistration.CarrierNo}} - {{batchRegistration.CarrierName}}</v-flex>
        </v-layout>
    </v-flex>
    <v-flex xs12 md6 :style="fieldColor()">
        <v-layout v-if="!isHide('Batches registered')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
          <v-flex class="font-weight-bold" d-flex xs4>{{$t("Batches registered")}}:</v-flex>
          <v-flex class="font-weight-bold" d-flex xs8>{{batchRegistration.RegistrationCount}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
        <v-flex d-flex xs8 style="padding-right: 6px">{{batchRegistration.ArticleNo}} - {{batchRegistration.ArticleName}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
        <v-flex d-flex xs8>{{batchRegistration.RequisitionNo}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Weight')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
          <v-flex d-flex xs4>{{$t("Weight")}}:</v-flex>
          <v-flex d-flex xs8>{{batchRegistration.WeightNet}} kg.</v-flex>
        </v-layout>
    </v-flex>
    </v-layout>
    <v-flex xs12 class="mb-4">
      <v-layout row wrap>
        <v-btn class="ml-3 mt-2 mr-3" :disabled="!batchRegistration.RegistrationCount" @click.prevent="preFinish" color="primary">{{$t('Finish')}}</v-btn>
        <v-flex grow></v-flex>
        <v-btn class="mt-1 mr-3 mb-n1" color="primary" :to="{name: 'batch-registration-create-registration', params: {id: batchRegistration.AgreementId}}">{{$t('Register weight')}}</v-btn>
      </v-layout>
    </v-flex>
    <v-card-actions style="padding: 0px 0px 0px 0px" v-if="batchRegistration.FinishedBy == null && !batchRegistration.Completed">
    </v-card-actions>
</v-card>

<v-dialog v-model="showArrivalDialog" max-width="600" @keydown.esc="showArrivalDialog = false" persistent>
    <v-card>
    <v-container fluid grid-list-md >
        <v-layout row wrap>
        <v-flex xs12 md12>
            <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
            <v-flex d-flex xs8>{{batchRegistration.AgreementName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{batchRegistration.CustomerName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Carrier')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Carrier")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{batchRegistration.CarrierName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{batchRegistration.ArticleName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{batchRegistration.RequisitionNo}}</v-flex>
            </v-layout>
        </v-flex>
        </v-layout>
    </v-container>
    <v-divider></v-divider>
    <v-card-actions>
        <v-container fluid grid-list-md  style="padding: 0px 0px 0px 14px">
        <v-layout row wrap>
            <v-flex xs12 md4>
            <v-flex d-flex xs12>{{$t("PreStatus3")}}</v-flex>
            </v-flex>
            <v-flex xs12 md3 align-self-center>
            <v-btn x color="error" @click="cancelArrivalAndReload">{{$t("Cancel")}}</v-btn>
            </v-flex>
            <v-flex xs12 md5 align-self-center>
            <v-btn color="success" @click="saveArrivalAndReload">{{$t("Register arrival")}}</v-btn>
            </v-flex>
        </v-layout>
        </v-container>
    </v-card-actions>
    </v-card>
</v-dialog>
<v-dialog
          v-model="areYouSureFinishDialog" max-width="400" persistent>
        <v-card>
          <v-card-title class="headline">{{$t("Finish")}}?</v-card-title>
          <template>
            <v-card-text class="font-weight-bold">{{$t("Do you really want to finish")}} {{$t("Agreement")}} {{batchRegistration.AgreementNo}}</v-card-text>
          </template>
          <v-card-actions>
            <v-spacer></v-spacer>
              <template>
                <v-btn ref="yesButton" color="success" @click="areYouSureFinishDialog = false; finishRegistration(batchRegistration)">{{$t("Yes")}}</v-btn>
                <v-btn ref="noButton" color="primary" @click="areYouSureFinishDialog = false" autofocus>{{$t("No")}}</v-btn>
              </template>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import * as batchRegistrationistration from '@/modules/batch-registration/batch-registration'
import * as Security from '@/core/security'
// import { Console } from 'console'

export default {
  components: { },
  props: ['batchRegistration'],
  data () {
    return {
      showScanDialog: false,
      showArrivalDialog: false,
      arrivalTitleGPS: false,
      distance: 0,
      userVehicleLicensePlateNo: '',
      videoReady: true,
      testVideoError: false,
      isCameraLoaded: false,
      isDecoding: false,
      hiddenFields: [],
      areYouSureFinishDialog: false,
      selectedReg: '#FFFFFF',
      active: false
    }
  },
  /* data: () => ({
    areYouSureFinishDialog: false
  }), */
  methods: {
    getCustomerStr (batchRegistration) {
      if (batchRegistration.CustomerNo && batchRegistration.CustomerName) { return batchRegistration.CustomerNo + ' - ' + batchRegistration.CustomerName } else if (batchRegistration.CustomerNo) { return batchRegistration.CustomerNo } else if (batchRegistration.CustomerName) { return batchRegistration.CustomerName } else { return '' }
    },
    fieldColor () {
      if (this.active) {
        return 'background:#81EFA6'
      }

      return 'background:#FFFFFF'
    },
    isActive () {
      return this.active
    },
    async finishRegistration (recentReg) {
      // console.log('key', event.key, this.areYouSureFinishDialog)
      this.loading = true
      const res = await batchRegistrationistration.FinishRegistration(recentReg.AgreementId)
      if (!res.failed) {
        this.registrations = res.data

        this.$root.$emit('msgloadBachRegistrations')
      }

      this.loading = false
    },
    async save (val) {
      this.showArrivalDialog = false
      this.batchRegistration.PreStatus = val
      const res = await batchRegistrationistration.saveRegistration(this.batchRegistration)
      if (!res.failed) {
        this.$root.$message.showSuccess(this.$t('PreStatus' + val))
        if (this.batchRegistration.PreStatus === 4) location.reload() // Fix so camera gets turned off (using a lot of cpu)
      }
    },
    removeKeyEvents () {
      document.removeEventListener('keydown', this.keyDown)
    },
    addKeyEvents () {
      document.addEventListener('keydown', this.keyDown)
    },
    keyDown (event) {
      if ((event.key === 'Escape')) {
        this.areYouSureFinishDialog = false
      }
      if (event.key === 'ArrowLeft' && (this.areYouSureFinishDialog)) {
        this.$refs.yesButton.$el.focus()
      }
      if (event.key === 'ArrowRight' && (this.areYouSureFinishDialog)) {
        this.$refs.noButton.$el.focus()
      }
    },
    isHide (fieldName) {
      return this.hiddenFields.some(h => h === fieldName)
    },
    preFinish () {
      this.areYouSureFinishDialog = true
    },
    cancelArrivalAndReload () {
      this.showArrivalDialog = false
      location.reload() // Fix so camera gets turned off (using a lot of cpu)
    },
    saveArrivalAndReload () {
      this.save(4) // 4 = Change to "Arrival registered, awaiting loading"
    }
  },
  beforeDestroy () {
    // Unsubscribe to event listener for events for keyboard
    this.removeKeyEvents()
  },
  async mounted () {
    // Load settings
    // Use Settings from cached user's corporatationDetails
    if (Security.user.corporationDetails) {
      const defaultHidden = 'RequisitionNo2,Comment'
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'batchRegistrationistration_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
    }
    this.addKeyEvents()
  }
}
</script>
